var render, staticRenderFns
import script from "./Dispute.vue?vue&type=script&lang=js"
export * from "./Dispute.vue?vue&type=script&lang=js"
import style0 from "./Dispute.vue?vue&type=style&index=0&id=2d393e5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports